module.exports = __webpack_public_path__ + "static/media/bg_kontakt_wide-1.81a5ae5a.jpg";